import convertPgStyleParamsToWixStyleParams from './convertPgStyleParamsToWixStyleParams/convertPgStyleParamsToWixStyleParams';
var defaultWixStyles = {
    calculateTextBoxWidthMode: 0,
    calculateTextBoxHeightMode: 0,
    textBoxWidthPercent: 50,
    textBoxWidth: 200,
    textBoxHeight: 200,
    textsVerticalPadding: 0,
    arrowsPadding: 23,
    arrowsSize: 23,
    galleryHorizontalAlign: 1,
    titleDescriptionSpace: 6,
    textsHorizontalPadding: 0,
    slideshowInfoSize: 200,
    textImageSpace: 10,
    itemBorderRadius: 0,
    galleryVerticalAlign: 1,
    imageMargin: 10,
    itemBorderWidth: 0,
    itemEnableShadow: false,
    itemShadowBlur: 20,
    itemShadowDirection: 135,
    itemShadowSize: 10,
    hoveringBehaviour: 0,
    scrollAnimation: 0,
    imageHoverAnimation: 0,
    overlaySizeType: 0,
    overlaySizeParam: 'overlaySizePercent',
    overlaySize: 100,
    overlayPadding: 0,
    overlayPosition: 2,
    overlayAnimation: 0,
    imageResize: 0,
    textBoxBorderWidth: 0,
    numberOfImagesPerCol: 1,
    numberOfImagesPerRow: 3,
    arrowsVerticalPosition: 0,
};
var getTouchUpUndoStateParam = function (isTouchUp, styleParamPrefix) {
    // Add touchUp - Undo cycle state style param
    return {
        type: 'boolean',
        key: styleParamPrefix + 'isTouchUpEnabled',
        value: {
            value: !isTouchUp
        }
    };
};
var getUndoStateSavingObj = function (galleryPrevSPs, styleParamPrefix) {
    // Add touchUp - Undo cycle state style param
    return {
        type: 'font',
        key: styleParamPrefix + 'galleryPrevSPs',
        value: {
            value: galleryPrevSPs
        }
    };
};
var getTypeAndValueFromWixStyles = function (wixStyles, param, prefix, defaultValue) {
    return {
        key: prefix + param,
        type: wixStyles[param]['type'],
        value: {
            value: wixStyles[param]['value'] || defaultValue,
        }
    };
};
/** Helper functions */
var textBoxWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var calculateTextBoxWidthMode = overwritingStyles.calculateTextBoxWidthMode;
    var textBoxWidthType = calculateTextBoxWidthMode === 'PERCENT' ? 'textBoxWidthPercent' : 'textBoxWidth';
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'calculateTextBoxWidthMode', stylePrefix, defaultWixStyles['calculateTextBoxWidthMode']),
        getTypeAndValueFromWixStyles(wixStyles, textBoxWidthType, stylePrefix, defaultWixStyles[textBoxWidthType]),
    ];
};
var textBoxHeightGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var calculateTextBoxHeightMode = overwritingStyles.calculateTextBoxHeightMode;
    var setParams = [
        getTypeAndValueFromWixStyles(wixStyles, 'calculateTextBoxHeightMode', stylePrefix, defaultWixStyles['calculateTextBoxHeightMode'])
    ];
    if (calculateTextBoxHeightMode === 'MANUAL') {
        setParams.push(getTypeAndValueFromWixStyles(wixStyles, 'textBoxHeight', stylePrefix, defaultWixStyles['textBoxHeight']));
    }
    return setParams;
};
var textsVerticalPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'textsVerticalPadding', stylePrefix, defaultWixStyles['textsVerticalPadding']),
    ];
};
var navigationArrowsGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'arrowsPadding', stylePrefix, defaultWixStyles['arrowsPadding']),
        getTypeAndValueFromWixStyles(wixStyles, 'arrowsSize', stylePrefix, defaultWixStyles['arrowsSize']),
        getTypeAndValueFromWixStyles(wixStyles, 'arrowsVerticalPosition', stylePrefix, defaultWixStyles['arrowsVerticalPosition']),
    ];
};
var textHorizontalAlignmentGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'galleryHorizontalAlign', stylePrefix, defaultWixStyles['galleryHorizontalAlign']),
    ];
};
var titleDescriptionSpaceGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'titleDescriptionSpace', stylePrefix, defaultWixStyles['titleDescriptionSpace']),
    ];
};
var textsHorizontalPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'textsHorizontalPadding', stylePrefix, defaultWixStyles['textsHorizontalPadding']),
    ];
};
// Check default case
var itemFontSlideshowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemFontSlideshow = overwritingStyles.itemFontSlideshow;
    // Added layer of protection in case the default case in convertPgStyleParamsToWix... will be removed
    if (!itemFontSlideshow)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemFontSlideshow', stylePrefix)
    ];
};
var itemFontGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemFont = overwritingStyles.itemFont;
    if (!itemFont)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemFont', stylePrefix)
    ];
};
var itemDescriptionFontSlideshowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemDescriptionFontSlideshow = overwritingStyles.itemDescriptionFontSlideshow;
    if (!itemDescriptionFontSlideshow)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemDescriptionFontSlideshow', stylePrefix)
    ];
};
var itemDescriptionFontGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemDescriptionFont = overwritingStyles.itemDescriptionFont;
    if (!itemDescriptionFont)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemDescriptionFont', stylePrefix)
    ];
};
var slideshowInfoSizeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'slideshowInfoSize', stylePrefix, defaultWixStyles['slideshowInfoSize'])
    ];
};
var textImageSpaceGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var textImageSpace = overwritingStyles.textImageSpace;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'textImageSpace', stylePrefix, defaultWixStyles['textImageSpace'])
    ];
};
var itemBorderRadiusGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemBorderRadius = overwritingStyles.itemBorderRadius;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemBorderRadius', stylePrefix, defaultWixStyles['itemBorderRadius'])
    ];
};
var isVerticalGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var isVertical = overwritingStyles.isVertical;
    // Unless explicitly stated, not changing user's isVertical
    if (!isVertical)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'isVertical', stylePrefix)
    ];
};
var galleryVerticalAlignGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'galleryVerticalAlign', stylePrefix, defaultWixStyles['galleryVerticalAlign'])
    ];
};
var collageDensityGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var collageDensity = overwritingStyles.collageDensity;
    if (!collageDensity)
        return;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'collageDensity', stylePrefix)
    ];
};
var imageMarginGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var imageMargin = overwritingStyles.imageMargin;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'imageMargin', stylePrefix, defaultWixStyles['imageMargin'])
    ];
};
var itemBorderWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemBorderWidth = overwritingStyles.itemBorderWidth;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'itemBorderWidth', stylePrefix, defaultWixStyles['itemBorderWidth'])
    ];
};
var itemShadowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var itemEnableShadow = overwritingStyles.itemEnableShadow;
    // SPs to set
    var setParams = [
        getTypeAndValueFromWixStyles(wixStyles, 'itemEnableShadow', stylePrefix, defaultWixStyles['itemEnableShadow'])
    ];
    var shadowParamsIfEnabled = [];
    if (itemEnableShadow === true) {
        shadowParamsIfEnabled = [
            getTypeAndValueFromWixStyles(wixStyles, 'itemShadowBlur', stylePrefix, defaultWixStyles['itemShadowBlur']),
            getTypeAndValueFromWixStyles(wixStyles, 'itemShadowDirection', stylePrefix, defaultWixStyles['itemShadowDirection']),
            getTypeAndValueFromWixStyles(wixStyles, 'itemShadowSize', stylePrefix, defaultWixStyles['itemShadowSize']),
        ];
    }
    return setParams.concat(shadowParamsIfEnabled);
};
var hoveringBehaviourGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'hoveringBehaviour', stylePrefix, defaultWixStyles['hoveringBehaviour']),
    ];
};
// here
var scrollAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'scrollAnimation', stylePrefix, defaultWixStyles['scrollAnimation'])
    ];
};
var imageHoverAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'imageHoverAnimation', stylePrefix, defaultWixStyles['imageHoverAnimation'])
    ];
};
var overlaySizeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var overlaySizeType = overwritingStyles.overlaySizeType;
    var overlaySizeParam = overlaySizeType === 'PIXEL' ? 'overlaySizePixel' : 'overlaySizePercent';
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'scrollAnimation', stylePrefix, defaultWixStyles['scrollAnimation']),
        getTypeAndValueFromWixStyles(wixStyles, 'overlaySize', stylePrefix, defaultWixStyles['overlaySize']),
    ];
};
var overlayPaddingGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    var overlayPadding = overwritingStyles.overlayPadding;
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'overlayPadding', stylePrefix, defaultWixStyles['overlayPadding'])
    ];
};
var overlayPositionGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'overlayPosition', stylePrefix, defaultWixStyles['overlayPosition'])
    ];
};
var overlayAnimationGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'overlayAnimation', stylePrefix, defaultWixStyles['overlayAnimation'])
    ];
};
var cubeTypeGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'imageResize', stylePrefix, defaultWixStyles['imageResize'])
    ];
};
var textBoxBorderWidthGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'textBoxBorderWidth', stylePrefix, defaultWixStyles['textBoxBorderWidth'])
    ];
};
var numberOfImagesPerColGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'numberOfImagesPerCol', stylePrefix, defaultWixStyles['numberOfImagesPerCol'])
    ];
};
var numberOfImagesPerRowGetter = function (overwritingStyles, stylePrefix, wixStyles) {
    return [
        getTypeAndValueFromWixStyles(wixStyles, 'numberOfImagesPerRow', stylePrefix, defaultWixStyles['numberOfImagesPerRow'])
    ];
};
// All style params we overwrite
var overwritingAutofixParams = {
    'textBoxWidth': textBoxWidthGetter,
    'textBoxHeight': textBoxHeightGetter,
    'navigationArrows': navigationArrowsGetter,
    'isVertical': isVerticalGetter,
    'textImageSpace': textImageSpaceGetter,
    'slideshowInfoSize': slideshowInfoSizeGetter,
    'itemFontSlideshow': itemFontSlideshowGetter,
    'itemFont': itemFontGetter,
    'itemDescriptionFont': itemDescriptionFontGetter,
    'itemDescriptionFontSlideshow': itemDescriptionFontSlideshowGetter,
    'textsVerticalPadding': textsVerticalPaddingGetter,
    'textsHorizontalPadding': textsHorizontalPaddingGetter,
    'itemBorderRadius': itemBorderRadiusGetter,
    'titleDescriptionSpace': titleDescriptionSpaceGetter,
    'galleryTextAlign': textHorizontalAlignmentGetter,
    'galleryVerticalAlign': galleryVerticalAlignGetter,
    'overlaySize': overlaySizeGetter,
    'overlayPadding': overlayPaddingGetter,
    'overlayPosition': overlayPositionGetter,
    'overlayAnimation': overlayAnimationGetter,
    'cubeType': cubeTypeGetter,
    'collageDensity': collageDensityGetter,
    'imageMargin': imageMarginGetter,
    'hoveringBehaviour': hoveringBehaviourGetter,
    'scrollAnimation': scrollAnimationGetter,
    'imageHoverAnimation': imageHoverAnimationGetter,
    'itemBorderWidth': itemBorderWidthGetter,
    'itemShadow': itemShadowGetter,
    'textBoxBorderWidth': textBoxBorderWidthGetter,
    'numberOfImagesPerCol': numberOfImagesPerColGetter,
    'numberOfImagesPerRow': numberOfImagesPerRowGetter,
};
export var setNewStylesFromTouchupServer = function (overwritingSPs, styleSetter, isMobile, isTouchUp, galleryPrevSPs) {
    var wixStyles = convertPgStyleParamsToWixStyleParams(overwritingSPs);
    var styleParamPrefix = isMobile ? "m_" : "";
    var overWritingSPArray = [];
    for (var _i = 0, _a = Object.keys(overwritingAutofixParams); _i < _a.length; _i++) {
        var sp = _a[_i];
        overWritingSPArray.push.apply(overWritingSPArray, (overwritingAutofixParams[sp](overwritingSPs, styleParamPrefix, wixStyles)));
    }
    overWritingSPArray.push(getTouchUpUndoStateParam(isTouchUp, styleParamPrefix));
    isTouchUp && overWritingSPArray.push(getUndoStateSavingObj(galleryPrevSPs, styleParamPrefix));
    styleSetter(overWritingSPArray);
};
//# sourceMappingURL=touchUpUtils.js.map